import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../../core/common/header/PageHeader";
import {
  FaBookOpen,
  FaUserGraduate,
  FaChartLine,
  FaTasks,
  FaPencilAlt,
  FaBook,
  FaClipboardList,
  FaMicrophone,
} from "react-icons/fa";

const MentorDashboard: React.FC = () => {
  const cards = [
    {
      title: "My Batches",
      description: "Manage and update your assigned Batch.",
      icon: FaBookOpen,
      link: "/mentor/my-batches",
      gradient: "from-blue-50 to-cyan-50",
    },
    {
      title: "Manage Quizzes",
      description: "View batch quiz results and statistics.",
      icon: FaUserGraduate,
      link: "/mentor/manage-quizzes",
      gradient: "from-purple-50 to-pink-50",
    },
    {
      title: "Batch Course Progress",
      description: "Update batch-level chapters (C1–C14) and Final Exam.",
      icon: FaTasks,
      link: "/mentor/batch-course-progress",
      gradient: "from-orange-50 to-amber-50",
    },
    {
      title: "Progress Overview",
      description: "View batch progress and student's performance.",
      icon: FaChartLine,
      link: "/mentor/progress-overview",
      gradient: "from-indigo-50 to-blue-50",
    },
    {
      title: "Assign Writing Tasks",
      description: "Assign writing tasks to your batches.",
      icon: FaPencilAlt,
      link: "/mentor/writing-tasks",
      gradient: "from-purple-50 to-pink-50",
    },
    {
      title: "Manage Homework (Hausaufgabe)",
      description: "View and assign homework to your batches.",
      icon: FaBook,
      link: "/mentor/homework",
      gradient: "from-rose-50 to-pink-50",
    },
    {
      title: "Manage Exams",
      description: "Grade student submissions and view exam results",
      icon: FaClipboardList,
      link: "/mentor/exam-management",
      gradient: "from-purple-50 to-pink-50",
    },
    {
      title: "Class Tests",
      description: "Grade class test submissions and enter Sprechen scores",
      icon: FaClipboardList,
      link: "/mentor/class-test-management",
      gradient: "from-cyan-50 to-blue-50",
    },
    {
      title: "Shadowing Tasks",
      description: "Assign shadowing tasks and review student recordings.",
      icon: FaMicrophone,
      link: "/mentor/shadowing-tasks",
      gradient: "from-orange-50 to-red-50",
    },
    {
      title: "Speaking Practice",
      description: "Listen to student speaking recordings and provide feedback.",
      icon: FaMicrophone,
      link: "/mentor/speaking-practice",
      gradient: "from-teal-50 to-cyan-50",
    },
    {
      title: "Task Checklist",
      description: "Tick weekly task assignments (homework, quiz, writing, class test, speaking).",
      icon: FaClipboardList,
      link: "/mentor/task-checklist",
      gradient: "from-green-50 to-emerald-50",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <PageHeader
        icon={<FaUserGraduate />}
        title="Mentor Dashboard"
        breadcrumb={[{ label: "Home", to: "/" }, { label: "Dashboard" }]}
      />

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <div className="mb-8 sm:mb-10">
          <p
            className="text-gray-700 text-base sm:text-lg"
            style={{ fontSize: "16px" }}
          >
            Welcome to your{" "}
            <span className="font-semibold text-[#009fe3]">Mentor Panel</span>.
            Manage your students, courses and communication here.
          </p>
        </div>

        <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((card, idx) => {
            const Icon = card.icon;

            return (
              <div key={idx} className="relative">
                <Link
                  to={card.link}
                  className={`block bg-gradient-to-br ${card.gradient} rounded-xl shadow-md border border-gray-200 hover:shadow-xl hover:border-[#009fe3]/30 transition-all duration-200 overflow-hidden h-full flex flex-col`}
                >
                  <div className="p-5 sm:p-6 flex-1">
                    <div className="w-12 h-12 mb-4 text-[#009fe3] bg-white/80 rounded-lg flex items-center justify-center shadow-sm">
                      <Icon size={24} />
                    </div>
                    <h2 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">
                      {card.title}
                    </h2>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {card.description}
                    </p>
                  </div>
                  <div className="bg-white/50 backdrop-blur-sm p-4 text-right mt-auto border-t border-gray-200/50">
                    <span className="text-sm font-semibold text-[#009fe3] inline-flex items-center gap-1">
                      View <span className="text-lg">→</span>
                    </span>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default MentorDashboard;
